import { HOTEL } from './../constants/Define';
import { getFilenameFromUrl } from '../helpers/functions';
import { getMomentDate } from '../utils/commonUtils';
import { orderBy, findIndex, get } from 'lodash';
import { getProvinceById, getProvinceByName } from './Province';
import BaseModel from './BaseModel';
export default class Hotel extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id;
        this.name = data.name || this.translate.name || undefined;
        this.code = data.code || this.translate.code || undefined;
        this.shortDescription = data.shortDescription || this.translate.shortDescription || undefined;
        this.description = data.description || this.translate.description || ''; // allow html code here;
        this.defaultRateDescription = this.translate.defaultRateDescription || data.defaultRateDescription || '';
        this.setTypes(data.types);
        this.address = data.address || this.translate.address || undefined;
        this.setProvince(data);
        this.country = data.country || '';
        this.locationId = data.locationId || data.location;
        this.setPosition(data);
        this.star = data.star || undefined;
        this.fax = data.fax || undefined;
        this.email = data.email || undefined;
        this.webAddress = data.webAddress || undefined;
        this.hotline = data.hotline || undefined;
        this.review = data.review || undefined;
        this.refId = data.refId || undefined;
        this.setMedia(data); // [{url, order, name}]
        this.amenity = (data.amenity || []).map(item => item.id)
        this.isActive = data.isActive !== undefined ? data.isActive : true;
        this.childPolicy = data.childPolicy || undefined;
        this.extraBedPolicy = data.extraBedPolicy || undefined;
        this.parkingShuttle = data.parkingShuttle || undefined;
        this.petPolicy = data.petPolicy || undefined;
        this.smokingPolicy = data.smokingPolicy || undefined;
        this.paymentPolicy = data.paymentPolicy || undefined;
        this.checkInTime = getMomentDate(data.checkInTime, undefined, false)
        this.checkOutTime = getMomentDate(data.checkOutTime, undefined, false);
        this.thumbnailTag = data.thumbnailTag || undefined;
        this.urlSlug = data.urlSlug || undefined;
        this.tripAdvisorLocationId = data.tripAdvisorLocationId || undefined;
        this.addressHyperLink = data.addressHyperLink || undefined;
        this.installmentFee = data.installmentFee || undefined;
        this.installmentLimit = data.installmentLimit || undefined;
        this.isBeachVilla = data.isBeachVilla || false;
        this.hardblock = data.hardblock || 0;
    }

    setTypes(types = []) {
        if (!types || !types.length) {
            this.types = [];
        }else{
            this.types = types.map(t => (HOTEL.TYPE[t.toUpperCase()] || t));
        }
        return this.types;
    }

    addMedia(url, name) {
        this.media.push({ url, order: this.media.length, name })
    }

    setMedia(data = {}) {
        this.media = data.media ? orderBy(data.media || [], ['order'], ['asc']) : (this.translate.media || []);
    }

    setPosition(data) {
        const position = {
            lat: Number(data.latitude || data.lat),
            lng: Number(data.longtitude || data.lng),
        }
        if (isNaN(position.lat) || isNaN(position.lng)) {
            this.position = undefined;
        } else {
            this.position = position;
        };
        return this.position;
    }

    setProvince(data) {
        this.province = data.province ? getProvinceByName(data.province) : (this.translate.province || undefined);
    }

    removeMedia(media) {
        let removeIndex;
        if (typeof media === 'string') {// by url
            removeIndex = findIndex(this.media, m => getFilenameFromUrl(m.url) === getFilenameFromUrl(media))
        } else if (typeof media === 'object' && media.order >= 0) {//by media object
            removeIndex = findIndex(this.media, m => m.order === media.order)
        } else {
            removeIndex = findIndex(this.media, (m, index) => this.media.indexOf(media) === index);
        }
        if (removeIndex >= 0) this.media = this.media.filter((m, index) => index !== removeIndex);
        this.media = this.media.map((m, index) => {
            if (index >= removeIndex) {
                m.order -= 1;
            }
            return m;
        })
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            name: this.name,
            code: this.code,
            types: this.types.length > 0 ? this.types : [HOTEL.TYPE.NOTSPECIFIED],
            description: this.description,
            defaultRateDescription: this.defaultRateDescription,
            shortDescription: this.shortDescription,
            address: this.address,
            star: this.star,
            hotline: this.hotline,
            review: this.review,
            refId: this.refId,
            locationId: this.locationId,
            province: getProvinceById(get(this, 'province.id')),
            latitude: String(get(this, 'position.lat') || ''),
            longtitude: String(get(this, 'position.lng') || ''),
            amenity: this.amenity.map(item => ({ id: item })),
            media: this.media,
            isActive: this.isActive,
            thumbnailTag: this.thumbnailTag,
            urlSlug: this.urlSlug,
            tripAdvisorLocationId: this.tripAdvisorLocationId,
            addressHyperLink: this.addressHyperLink,
            installmentFee: this.installmentFee,
            installmentLimit: this.installmentLimit,
            isBeachVilla: this.isBeachVilla,
            hardblock: this.hardblock,
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                hotelId: this.translate.hotelId || this.id,
                name: this.name,
                code: this.code,
                description: this.description,
                defaultRateDescription: this.defaultRateDescription,
                shortDescription: this.shortDescription,
                address: this.address,
                province: getProvinceById(get(this, 'province.id')),
                media: this.media,
                thumbnailTag: this.thumbnailTag,
                urlSlug: this.urlSlug,
                languageCode: this.languageCode,
            }
        }
        return result;
    }

}
export class Amenity {
    constructor(data = {}) {
        this.id = data.id || undefined;
        this.name = data.name || undefined;
        this.code = data.code || undefined;
        this.description = data.description || undefined;
        this.url = data.url || undefined;
        this.order = data.order || 0;
    }
}
